import React from 'react';
import { formatDollar } from '../../../helpers/utils';
const Row = ({
  employee,
  text,
  accent_color
}) => {
  var _employee$employee;
  return /*#__PURE__*/React.createElement("div", {
    className: `list-row list-item ${employee.isNew && 'list-item-own'}`,
    style: {
      '--accent-color': accent_color
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "name"
  }, /*#__PURE__*/React.createElement("span", {
    className: "ranking-prefix"
  }, employee.ranking, "."), " ", (_employee$employee = employee.employee) === null || _employee$employee === void 0 ? void 0 : _employee$employee.toLowerCase()), employee.isNew && /*#__PURE__*/React.createElement("div", {
    className: "new-item",
    style: {
      color: text.accent_color
    }
  }, "NEW!"), /*#__PURE__*/React.createElement("div", {
    className: "amount"
  }, employee.avg ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, formatDollar(employee.avg, 2)), /*#__PURE__*/React.createElement("div", {
    className: `variance ${employee.delta >= 0 ? 'positive' : 'negative'}`
  }, /*#__PURE__*/React.createElement("div", {
    className: `arrow ${employee.delta >= 0 ? 'up' : 'down'}`
  }), /*#__PURE__*/React.createElement("div", {
    className: "value"
  }, /*#__PURE__*/React.createElement("b", null, formatDollar(employee.delta, 2))))) : '-'));
};
export default Row;